module.exports = __webpack_public_path__ + "static/media/about-img-4.96076558.jpg";